import type { IconProps } from '../types/IconProps.ts';
export const TagX: IconProps = {
    name: 'TagX',
    children: [
        `<path d="m16 6-4.24-3.72a1 1 0 0 0-.69-.28H3a1 1 0 0 0-1 1v8.57a1 1 0 0 0 .31.73l9.49 9.01a1 1 0 0 0 1.41-.04L17.27 17" />`,
        `<path d="M6.5 7a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M17 13l4-4M17 9l4 4" />`,
    ]
};